import React from 'react';
import { useParams } from 'react-router-dom';

import { Sudoku } from './Game';
import { SudokuProvider } from './SudokuContext';

/**
 * Rota `/jogo/sudoku/:id`. O `key` remonta contexto e sessão quando o id muda com a rota
 * montada (ex.: link do menu para outro sudoku): sem isso, o estado do jogo A seria salvo
 * e finalizado no jogo B. A tela recebe o id por prop, nunca do `useParams`.
 */
const SudokuHookProvider: React.FC = () => {
  const jogoId = Number(useParams().id);
  return (
    <SudokuProvider key={jogoId}>
      <Sudoku jogoId={jogoId} />
    </SudokuProvider>
  );
};

export default SudokuHookProvider;
